/**
 * Resource danh mục loại tài sản/tang vật
 * ndquang1 16.5.2024
 */
export default {
  Title: 'Danh mục loại tài sản/tang vật',
  Code: 'Mã loại *',
  CodeTitle: 'Mã loại',
  Name: 'Tên loại *',
  NameTitle: 'Tên loại',
  Kind: 'Thuộc loại',
  Description: 'Ghi chú',
};
